<style scoped>
  .badge {
    background-color: rgb(165, 29, 29) !important;
  }
  .bg-notif-header {
    background-color: #152b51 !important;
  }
  .mw-75 {
    max-width: 75% !important;
  }
</style>

<template>
 
  <CHeader fixed with-subheader style="background:#1a3665;color:white">
    <div>
      <audio id="notificatidon" src="https://soundbible.com/mp3/Air Plane Ding-SoundBible.com-496729130.mp3"  muted="false"></audio>
    </div>
    <CToggler in-header style="color:white !important" class="ml-3 d-lg-none"
      @click="$store.commit('toggleSidebarMobile')" />

    <CToggler in-header style="color:white !important" class="ml-3 d-md-down-none text-white"
      @click="$store.commit('toggleSidebarDesktop')" />

    <CHeaderNav class="d-md-down-none mr-auto">
      <CHeaderNavItem class="px-3">
        <CHeaderNavLink to="/log-activity" style="color:white">
          <i class="c-sidebar-nav-icon fas fa-clock"></i>
          <!-- <span class="badge badge-danger ml-3">0</span> -->
        </CHeaderNavLink>
      </CHeaderNavItem>
      <CHeaderNavItem class="px-3" id="dropdownMenu" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
        <CHeaderNavLink  style="color:white">
          <i class="c-sidebar-nav-icon fas fa-bell"></i>          
          <span class="badge badge-danger">{{ notif_props.length }}</span>                    
        </CHeaderNavLink>
        
      </CHeaderNavItem>
      
      <div class="dropdown-menu shadow border-0 pt-0 mw-75" aria-labelledby="dropdownMenu">
        <h6 class="dropdown-header text-white bg-notif-header text-left py-3">
          Notifikasi
        </h6>
        
        <a class="dropdown-item" href="#" v-if="notif_props.length < 1" >Tidak ada pemberitahuan baru.</a>
        <a class="dropdown-item text-wrap" href="#" v-for="(val,index) in notif_props" :key="index">{{ val.title + " | "+ val.message + val.title }}</a>
      </div>
    </CHeaderNav>
    
    <CHeaderNav class="mr-4 ml-auto">

    <TheHeaderDropdownAccnt />
    </CHeaderNav>
      <CSubheader class="px-3">
        <CBreadcrumbRouter class="border-0 mb-0" />
      </CSubheader>
    </CHeader>
    
</template>

<script>
import authHeader from "../services/auth-header";
import SockJS from "sockjs-client";
import Stomp from "webstomp-client";

  import TheHeaderDropdownAccnt from "./TheHeaderDropdownAccnt";
import baseUrl from "../services/base-url"
import { AlertUtils } from "../mixins/AlertUtils"
import axios from "axios";
  export default {
    props : [
      'notif_props'
    ],
    mixins : [AlertUtils],
    name: "TheHeader",
    data() {
      return {
       base_url_backend : process.env.VUE_APP_BASE_URL_BACKEND,
      received_messages: [],
      header : '',
      send_message: null,
      connected: false,
        totalNotif: 0,
      };
    },
    mounted(){
      // this.header = this.indoLang.header
      // this.getNotif();
      // this.send()
      // this.connect();
    },
    watch : {
      totalNotif : function (oldTotalNotif, newTotalNotif) {
        // comment console console.log("old old")
        // comment console console.log(oldTotalNotif);
        // comment console console.log("old old")
        // comment console console.log("=====")

        // comment console console.log("new")
        // comment console console.log(newTotalNotif);
        // comment console console.log("new")
        this.alertSuccess();

         document.getElementById('notification').muted = false;
        document.getElementById('notification').play();
      }
    },
    methods : {
      send() {
         alert("hahah")
        // comment console console.log("Send message:" + this.send_message);
        if (this.stompClient && this.stompClient.connected) {
          const msg = { 
            sender: "message",
            content: "message"
          };
          this.stompClient.send("/app/notif.back-office.register", JSON.stringify(msg), {});
        }
      },
      connect() {
        this.socket = new SockJS(base_url_backend+"/notification-back-office");
        this.stompClient = Stomp.over(this.socket);
        this.stompClient.connect(
          {},
          frame => {
            this.connected = true;
            // comment console console.log(frame);
            this.stompClient.subscribe("/back-office-notification", tick => {
              // comment console console.log("INI NOTIFFFFF")
              // comment console console.log(tick);
              // this.item.push(JSON.parse(tick.body).content);
            });
          },
          error => {
            // comment console console.log(error);
            this.connected = false;
          }
        );
      },
      disconnect() {
        if (this.stompClient) {
          this.stompClient.disconnect();
        }
        this.connected = false;
      },
      tickleConnection() {
        this.connected ? this.disconnect() : this.connect();
      },
      notif() {
        var audio = new Audio();
          audio.play();
      },
      getNotif() {
        setInterval(() => {
              // $('scanqr').reload(document.URL + '#scanqr');
              axios
              .get(baseUrl()+"/api/all/notification-satuan", {
                headers: authHeader()
              })
              .then(response => {
                // return true;
                this.totalNotif = response.data.count
                this.item = response.data.notif
                
              })
              .catch(error => {
               // comment console console.log(error)
              });
              
          }, 3000);
          
      }
    },
    // 
    components: {
      TheHeaderDropdownAccnt
    }
  };
</script>